import { createTheme } from '@material-ui/core';

export const materialUITheme = createTheme({ palette: { primary: { main: "#7F00FF" } } });